import React from 'react';
import Box from './Box';
import { MdOutlineDescription, MdOutlineLocationCity, MdOutlineWarningAmber } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
    const { t } = useTranslation();
    return (
        <div>
            <div className={'margin-home my-20 flex flex-wrap justify-center gap-10'}>
                <Box
                    title={t('translation:MAIN_PAGE.FAQ.1.TITLE')}
                    content={<p>{t('translation:MAIN_PAGE.FAQ.1.CONTENT')}</p>}
                    icon={<MdOutlineWarningAmber />}
                />

                <Box
                    title={t('translation:MAIN_PAGE.FAQ.2.TITLE')}
                    content={<p>{t('translation:MAIN_PAGE.FAQ.2.CONTENT')}</p>}
                    icon={<MdOutlineLocationCity />}
                />
                <Box
                    title={t('translation:MAIN_PAGE.FAQ.3.TITLE')}
                    content={<p>{t('translation:MAIN_PAGE.FAQ.3.CONTENT')}</p>}
                    icon={<MdOutlineDescription />}
                />
            </div>
        </div>
    );
}
